import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=af53d150&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af53d150')) {
      api.createRecord('af53d150', component.options)
    } else {
      api.reload('af53d150', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=af53d150&", function () {
      api.rerender('af53d150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KHYc7o3F7gYz/JS/offershelp.vue"
export default component.exports